// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qfUR","top":"styles_top__rWvVG","left":"styles_left__2IjPJ","description":"styles_description__3Ik_L"};